import {Observable, ReplaySubject, Subscription} from "rxjs";

export interface WebSocketConnection {
  send$: ReplaySubject<string>;
  receive$: Observable<string>;
  ping?: Subscription;
  reconnect?: Subscription;
  updateConnection?: Subscription;
  finish: () => void;
}

export enum ConnectionType {
  LiveChat = 'livechat'
}
